import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { router } from "@/router";
import { queryClient } from "@/lib/queryClient";
import { bootstrapAuth } from "@/lib/axios";
import { useAuthStore } from "@/modules/auth/store/auth.store";
import { Toaster } from "@/components/ui/Toast";
import { TooltipProvider } from "@/components/ui/Tooltip";
import { I18nProvider } from "@/i18n";

/**
 * App — to'liq tahsiniy darvoza.
 *
 * Mount paytida `bootstrapAuth()` chaqiriladi:
 * - Refresh cookie bor bo'lsa — yangi access token + user/tenant snapshot olinadi
 * - Yo'q bo'lsa — store tozalanadi
 */
export default function App() {
  useEffect(() => {
    bootstrapAuth().catch(() => {
      useAuthStore.getState().clear();
    });
    // Cleanup — eski sidebar akkordion holati endi ishlatilmaydi
    try {
      window.localStorage.removeItem("sidebar-groups");
    } catch {
      // ignore
    }
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <I18nProvider>
        <TooltipProvider delayDuration={200} skipDelayDuration={300}>
          <RouterProvider router={router} />
          <Toaster />
        </TooltipProvider>
      </I18nProvider>
    </QueryClientProvider>
  );
}
